import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionFormat {
    public static getDetailSite(common: CommonService) {
        const param = {
            'servlet': 'DBGetInfoSite',
            'module': 'Recylog',
            'type': 'tableau',
            'compression': 'false',
            'data': ['DBGetInfoSite', '' + common.user[2]]
        };

        return common.post('', { param: param });
    }

    public static getFormatperso(clefTypeFormat, common: CommonService, isSpinner?) {
        const param = {
            'servlet': 'DBGestionFormatParametrable',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 3
                },
                'CLEF_TYPE_FORMAT': {
                    'typeParam': 'int',
                    'valeur': clefTypeFormat
                }
            }
        };

        return common.post('', { param: param }, isSpinner || false);
    }
    
    public static getFormatParametrableNonMasque(clefTypeFormat, common: CommonService) {
        const param = {
            'servlet': 'DBGestionFormatParametrable',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 13
                },
                'CLEF_TYPE_FORMAT': {
                    'typeParam': 'int',
                    'valeur': clefTypeFormat
                }
            }
        };

        return common.post('', { param: param });
    }

}
